import { gql } from '@apollo/client';

const GET_SKUS_BY_PROVIDERS = gql(`
  query skusByProvider($partnerId: String!, $providerId: String!) {
    skusByProvider(partnerId: $partnerId, providerId: $providerId) {
      name
      key
      genieStatus
      planVendingEnabled
      isGeneric
      providerConfigStatus {
        providerId
        enabledInQA
        enabledInProd
      }
    }
  }
`);

export { GET_SKUS_BY_PROVIDERS };
